// extracted by mini-css-extract-plugin
module.exports = {"announcement":"Topbar_announcement__3dE66","banner":"Topbar_banner__g7j18","rightBanner":"Topbar_rightBanner__sFH1V","bannerText":"Topbar_bannerText__LxQtM"};